import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../../../contexts/AuthContext";

const BASE_API = process.env.REACT_APP_ORDER_SERVICE_URL;
const API = axios.create({
  baseURL: BASE_API,
});

export default function OrdersPage() {
  const { auth } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const size = 20; // match backend default

  useEffect(() => {
    if (!auth?.userId) return;

    const loadOrders = async () => {
      setLoading(true);
      try {
        const res = await API.get(
          `/orders/user/${auth.userId}?page=${page}&size=${size}`,
          {
            headers: { Authorization: `Bearer ${auth.token}` },
          }
        );

        const data = res.data || {};
        setOrders(data.content || []);
        setTotalPages(data.totalPages || 1);
      } catch (e) {
        console.error(e);
        setOrders([]);
      } finally {
        setLoading(false);
      }
    };

    loadOrders();
  }, [auth, page]);

  return (
    <div>
      <h3 className="fw-bold">Your Orders</h3>
      <p className="text-muted">Track and manage your order history.</p>

      {loading ? (
        <p>Loading...</p>
      ) : orders.length === 0 ? (
        <div className="alert alert-info mt-3">You have no orders yet.</div>
      ) : (
        <>
          <table className="table table-hover mt-3">
            <thead>
              <tr>
                <th>Reference</th>
                <th>Status</th>
                <th>Total</th>
                <th>Payment</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.id}>
                  <td>{o.reference}</td>
                  <td>{o.status}</td>
                  <td>
                    {o.totalAmount?.toLocaleString(undefined, {
                      style: "currency",
                      currency: o.currency || "USD",
                    })}
                  </td>
                  <td>{o.paymentStatus}</td>
                  <td>
                    {o.createdDate
                      ? new Date(o.createdDate).toLocaleString()
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Simple pagination */}
          <div className="d-flex justify-content-between align-items-center mt-3">
            <button
              className="btn btn-outline-primary"
              disabled={page <= 0}
              onClick={() => setPage((p) => p - 1)}
            >
              Prev
            </button>
            <span>
              Page {page + 1} of {totalPages}
            </span>
            <button
              className="btn btn-outline-primary"
              disabled={page + 1 >= totalPages}
              onClick={() => setPage((p) => p + 1)}
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
}
